import { SET_IS_LOADING } from './constants';

const defaultState = {
  isLoading: false
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action?.isLoading
      }
    }
    default: {
      return state;
    }
  }
}